export const DocxDraftType = ((DocxDraftType) => {
    DocxDraftType.OFFER = "offer";
    DocxDraftType.AGREEMENT = "agreement";
    return DocxDraftType;
})({});
